import { render, staticRenderFns } from "./TempAccountCreate.vue?vue&type=template&id=1b2aa776"
import script from "./TempAccountCreate.vue?vue&type=script&lang=ts"
export * from "./TempAccountCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports